<template>
    <div
        class="flex flex-col justify-start w-screen md:w-full pt-5 pb-4 mx-auto mt-6 md:max-w-3xl lg:max-w-3xl bg-slate-50 md:rounded-lg md:pt-8 md:pb-5 md:px-6 lg:mt-8"
    >
        <div class="flex flex-row justify-between px-6 md:px-0 mb-6">
            <h3 v-text="t('show.section_videos_highlight')"></h3>
            <div
                v-if="videos.length > 1"
                class="flex flex-row block"
            >
                <i
                    class="w-6 h-6 icon icon-chevron-circled-left bg-slate-300"
                    data-click="video carousel, previous"
                    @click="$refs.videoCarousel.goToPrev()"
                ></i>
                <i
                    class="w-6 h-6 icon icon-chevron-circled-right bg-slate-300"
                    data-click="video carousel, next"
                    @click="$refs.videoCarousel.goToNext()"
                ></i>
            </div>
        </div>
        <VueAgile
            ref="videoCarousel"
            :options="optionsCarousel"
            class=""
        >
            <div
                v-for="(video, index) in videos"
                :key="video._id"
                class="slide py-1 px-7 md:px-1"
            >
                <div class="md:mr-5 shadow rounded-lg overflow-hidden">
                    <div
                        class="relative slide-image-container"
                        :title="video.headline"
                        @click="openVideo(index + 1)"
                    >
                        <div class="absolute flex flex-row items-center justify-center w-full h-full">
                            <div
                                class="flex flex-col items-center justify-center duration-500 ease-in-out bg-opacity-50 rounded-full bg-black hover:scale-110"
                            >
                                <i
                                    class="m-4 icon icon-triangle-right w-9 h-9 bg-white"
                                    :data-click="`videos,${video.url}`"
                                ></i>
                            </div>
                        </div>
                        <img
                            :src="video.picture ? video.picture : '/images/opengraph/sharing-default@3x.png'"
                            class="object-cover w-full h-full mx-auto"
                        />
                    </div>
                    <div class="flex flex-col w-full px-4 pt-4 pb-5 md:pb-6 lg:pb-8 bg-white">
                        <h4 class="mb-3 text-base leading-normal text-blue-600 md:text-lg font-normal">
                            {{ video.headline }}
                        </h4>
                        <p
                            class="text-xs font-normal leading-normal text-slate-600 md:text-base"
                            v-text="video.description"
                        ></p>
                    </div>
                </div>
            </div>
        </VueAgile>
        <Lightbox
            v-if="videos.length > 0"
            v-model="toggleVideo"
            :slide="slide"
            :sources="videoSources"
        />
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import { mapActions } from 'vuex';
import Lightbox from '@/components/Lightbox';
import { isServiceAllowed } from '@/utils/usercentricsUtils';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'CompanyShowVideoCarousel',
    components: {
        Lightbox,
        VueAgile,
    },
    props: {
        videos: {
            type: Array,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('company');
        return { t };
    },
    data() {
        return {
            toggleVideo: false,
            slide: 1,
            optionsCarousel: {
                centerMode: false,
                dots: false,
                infinite: true,
                navButtons: false,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 320,
                        settings: {
                            centerMode: true,
                            slidesToShow: 1,
                            infinite: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            centerMode: true,
                            slidesToShow: 2,
                            infinite: false,
                        },
                    },
                ],
            },
        };
    },
    computed: {
        videoSources() {
            return this.videos.map((video) => video.url);
        },
    },
    methods: {
        ...mapActions('flashMessages', ['showError', 'dismiss']),
        openVideo(number) {
            isServiceAllowed('YouTube Video').then((status) => {
                if (status) {
                    this.slide = number;
                    this.toggleVideo = true;
                } else {
                    this.showError({
                        content: this.t('cookieErrors.youTube'),
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.slide-image-container {
    height: 164px;
    @screen md {
        height: 186px;
    }
}
</style>
